// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"1a4a2572","566":"1a4a2572"}[chunkId] + ".chunk.css";
};